// removed by extract-text-webpack-plugin
module.exports = {"HeroImage":"Landing__HeroImage__3OWY0","HeroText":"Landing__HeroText__Xtrnb"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Landing/Landing.css
// module id = 154
// module chunks = 3